// src/pages/ProfileGate/steps/GetStartedStep.jsx

import React from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  OnboardingInterstitial,
} from "../OnboardingVisuals";

const GET_STARTED_PENGUIN_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Gwin_Clipboard.png";

export default function GetStartedStep() {
  const navigate =
    useNavigate();

  return (
    <OnboardingInterstitial
      message="Let’s make Gwin useful for your business."
      secondaryMessage="I’ll ask you a few quick questions so I can understand where you’re starting and what you’d like help with."
      showBack={true}
      showSpeechPenguin={false}
      nextLabel="Get started"
      onBack={() =>
        navigate(
          "/profile-gate/welcome"
        )
      }
      onNext={() =>
        navigate(
          "/profile-gate/focus"
        )
      }
    >
      <div className="mx-auto mt-9 w-[54%] max-w-[250px]">
        <img
          src={
            GET_STARTED_PENGUIN_URL
          }
          alt="Gwin"
          className="h-auto w-full object-contain"
          loading="eager"
          decoding="async"
          draggable="false"
        />
      </div>
    </OnboardingInterstitial>
  );
}